import React from "react"

const LoadingComponent = () => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100 dark:bg-gray-900">
      <div className="flex flex-col items-center space-y-4">
        {/* Spinner */}
        <div className="relative h-16 w-16">
          <div className="absolute h-full w-full animate-spin rounded-full border-4 border-blue-500 border-t-transparent"></div>
        </div>

        {/* Loading Text */}
        <p className="text-lg font-medium text-gray-800 dark:text-gray-200">Loading...</p>
      </div>
    </div>
  )
}

export default LoadingComponent